export default __webpack_public_path__ + "static/media/background.7f53bb3d.jpg";